import React from 'react';

interface CalendarPickerProps {
  className?: string;
  width?: number;
  height?: number;
}

const CalendarPickerIcon = function CalendarPickerIcon({
  className,
  width,
  height,
}: CalendarPickerProps): JSX.Element {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      width={width}
      height={height}
      viewBox="0 0 24 24"
    >
      <rect x="3" y="6" width="18" height="15" rx="2" fill="#222222" fillOpacity="0.03" stroke="#222222" strokeOpacity="0.25" />
      <path d="M3 8C3 6.89543 3.89543 6 5 6H19C20.1046 6 21 6.89543 21 8V10H3V8Z" fill="#222222" fillOpacity="0.5" />
      <path d="M7 3L7 6" stroke="#8D8D8D" strokeOpacity="0.5" strokeLinecap="round" />
      <path d="M17 3L17 6" stroke="#8D8D8D" strokeOpacity="0.5" strokeLinecap="round" />
    </svg>
  );
};

CalendarPickerIcon.defaultProps = {
  className: '',
  width: 24,
  height: 24,
};

export default CalendarPickerIcon;
